import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import classNames from 'classnames';
import { MentionsInput as CommentInput, Mention } from 'react-mentions';

class CommentForm extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      markup: '',
      body: '',
      collapsed: true,
      loading: false,
      active: false,
      error: false,
    };
    this.state = this.initialState;
    this.handleFocus = this.handleFocus.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleReplyButtonClick = this.handleReplyButtonClick.bind(this);
    this.reset = this.reset.bind(this);
  }

  get isEmpty() {
    return isEmpty(this.state.body.trim());
  }

  handleFocus() {
    this.setState({ collapsed: false });
  }

  handleBlur() {
    if (this.isEmpty) this.reset();
  }

  handleSubmit(e) {
    if (e) e.preventDefault();
    if (this.state.loading) return;
    const { markup: body } = this.state;
    this.setState({ loading: true });
    this.props
      .postComment({ body })
      .then(() => {
        try {
          this.commentInput.wrappedInstance.refs.input.blur();
        } catch (error) {} // eslint-disable-line
        this.reset();
      })
      .catch(() => {
        setTimeout(() => {
          this.handleError();
        }, 500);
      });
  }

  handleChange(e, markup, body) {
    this.setState({ markup, body });
  }

  handleKeydown(e) {
    if (e.keyCode === 13 && e.metaKey && !this.isEmpty) {
      this.handleSubmit();
    }
  }

  handleReplyButtonClick() {
    this.setState({ active: true }, () => {
      try {
        this.commentInput.wrappedInstance.refs.input.focus();
      } catch (error) {} // eslint-disable-line
    });
  }

  reset() {
    this.setState(this.initialState);
  }

  handleError() {
    this.setState({ loading: false, error: true });
  }

  renderSuggestion({ email }, search, highlightedDisplay) {
    return (
      <div className="MentionItem">
        {highlightedDisplay}
        <div className="MentionItem--email">{email}</div>
      </div>
    );
  }

  renderReplyButton() {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid
      <a
        className="CommentForm-replyButton"
        onClick={this.handleReplyButtonClick}
        children="+ Reply"
      />
    );
  }

  render() {
    const { loading, collapsed, markup, active, error } = this.state;
    if (this.props.useReplyButton && !active) return this.renderReplyButton();
    const formClassName = classNames('CommentForm', {
      'CommentForm--loading': loading,
    });

    return (
      <form className={formClassName} onSubmit={this.handleSubmit}>
        <CommentInput
          value={markup}
          ref={component => {
            this.commentInput = component;
          }}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          className="CommentForm-input"
          placeholder={this.props.placeholder}
          displayTransform={(id, display) => `@${display}`}
          onKeyDown={this.handleKeydown}
          disabled={loading}
          style={{ opacity: loading ? 0.5 : null }}
        >
          <Mention
            className="CommentForm-mention"
            trigger="@"
            data={this.props.lessonOwners}
            renderSuggestion={this.renderSuggestion}
            appendSpaceOnAdd
          />
        </CommentInput>
        {error && (
          <div className="CommentForm-errorMessage Animated Animated--slideIn">
            There was a problem posting your comment.
          </div>
        )}
        {!collapsed && (
          <div className="CommentForm-buttons">
            <button
              type="button"
              onClick={this.reset}
              className="CommentForm-cancelComment NewButton NewButton--flat"
              children="Cancel"
              disabled={loading}
            />
            <button
              type="submit"
              className="NewButton NewButton--blue CommentForm-submitButton"
              disabled={this.isEmpty || loading}
              children={this.props.buttonText}
            />
          </div>
        )}
      </form>
    );
  }
}

const mapStateToProps = state => ({
  lessonOwners: state.meta.lessonOwners,
});

export default connect(mapStateToProps)(CommentForm);
